/**
 * Landing Declaration Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: support@indigo.si
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EPrinterPaperStatus = 'Ok' | 'Empty' | 'NearEnd';

export const EPrinterPaperStatus = {
    Ok: 'Ok' as EPrinterPaperStatus,
    Empty: 'Empty' as EPrinterPaperStatus,
    NearEnd: 'NearEnd' as EPrinterPaperStatus
};

